import { render, staticRenderFns } from "./CallDetail.vue?vue&type=template&id=dde917f2&scoped=true&"
import script from "./CallDetail.vue?vue&type=script&lang=js&"
export * from "./CallDetail.vue?vue&type=script&lang=js&"
import style0 from "./CallDetail.vue?vue&type=style&index=0&id=dde917f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde917f2",
  null
  
)

export default component.exports